import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M19.264 18.738C19.264 19.217 18.879 19.605 18.403 19.605C17.927 19.605 17.542 19.217 17.542 18.738C17.542 18.259 17.927 17.871 18.403 17.871C18.879 17.871 19.264 18.259 19.264 18.738Z"
      fill="currentColor"
    />
    <path
      d="M19.05 6.14H13.623C13.648 6.079 13.702 5.989 13.808 5.881L16.115 3.563C16.383 3.293 16.383 2.856 16.115 2.587C15.847 2.318 15.411 2.318 15.142 2.587L12.833 4.907C12.277 5.472 12.089 6.157 12.332 6.739C12.532 7.221 12.989 7.52 13.524 7.52H19.05C19.919 7.52 20.625 8.233 20.625 9.109V18.644C20.625 19.52 19.919 20.233 19.05 20.233H4.947C4.08 20.233 3.375 19.52 3.375 18.644V9.11C3.375 8.234 4.08 7.521 4.947 7.521H10.499C11.034 7.521 11.491 7.222 11.691 6.74C11.933 6.157 11.746 5.472 11.188 4.905L8.896 2.602C8.628 2.332 8.192 2.332 7.924 2.602C7.656 2.872 7.655 3.309 7.924 3.578L10.212 5.878C10.32 5.988 10.374 6.078 10.399 6.14H4.947C3.322 6.14 2 7.473 2 9.11V18.645C2 20.283 3.322 21.615 4.947 21.615H19.05C20.676 21.615 22 20.283 22 18.645V9.11C22 7.473 20.676 6.14 19.05 6.14V6.14Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'TvSet');

export default Icon;
